<ng-container *transloco="let t; read: 'slotProducts'">
  <ng-container *transloco="let tGlobal; read: 'global'">
    @if (vm$ | async; as vm) {
      <a (click)="openSlotProductDialog()" class="addIcon" class="addIcon" [hidden]="!('Permissions.SlotProducts.Create' | permission)">
        <span class="icon">
          <img src="../../../assets/icons/add-icon.svg">
        </span>
        {{t('add')}}
      </a>
      <form [formGroup]="slotProductForm" class="xs12col">
        <kendo-grid
          [data]="vm.slotProducts"
          [rowClass]="rowClass"
          [skip]="skip"
          [loading]="vm.loading"
          [pageable]="false"
          [navigable]="true">
          <!-- DESKTOP GRID -->
          <kendo-grid-column field="product.name" [title]="t('name')" media="(min-width: 993px)">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.product.name }}
              @if (!dataItem.product.isActive && dataItem.product.inactiveReason) {
                <span class="tooltipContainer">
                  <span [attr.tooltip]="dataItem.product.inactiveReason" flow="right" class="tooltipContainer">
                    <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                  </span>
                </span>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="product.internalNumber" [title]="t('internalNumber')" media="(min-width: 993px)">
            <ng-template let-dataItem>
              {{ dataItem.product.internalNumber }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="targetStock" [title]="t('targetStock')" media="(min-width: 993px)">
            <ng-template let-dataItem>
              {{ dataItem.targetStock }}
            </ng-template>
          </kendo-grid-column>
          <!-- MOBILE GRID -->
          <kendo-grid-column field="product.name" media="(max-width: 992px)">
            <ng-template kendoGridCellTemplate let-dataItem>
              <h4 class="mobileGridHeader">{{t('name')}}</h4>
              <span>{{ dataItem.product.name }}</span>
              @if (!dataItem.product.isActive && dataItem.product.inactiveReason) {
                <span class="tooltipContainer">
                  <span [attr.tooltip]="dataItem.product.inactiveReason" flow="right" class="tooltipContainer">
                    <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                  </span>
                </span>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="product.internalNumber" media="(max-width: 992px)">
            <ng-template kendoGridCellTemplate let-dataItem>
              <h4 class="mobileGridHeader">{{t('internalNumber')}}</h4>
              <span>{{ dataItem.product.internalNumber }}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="targetStock" media="(max-width: 992px)">
            <ng-template kendoGridCellTemplate let-dataItem>
              <h4 class="mobileGridHeader">{{t('targetStock')}}</h4>
              <span>{{ dataItem.targetStock }}</span>
            </ng-template>
          </kendo-grid-column>
          <!-- GLOBAL COMMAND COLUMN -->
          <kendo-grid-command-column
            [title]=""
            [hidden]="!('Permissions.SlotProducts.Update' | permission) || !('Permissions.SlotProducts.Delete' | permission)">
            <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
              <a
                [attr.tooltip]="tGlobal('edit')"
                flow="up"
                (click)="openSlotProductDialog(dataItem)"
                class="actionIcon">
                <img src="../../../assets/icons/edit-icon.svg">
              </a>
              <a
                [attr.tooltip]="tGlobal('delete')"
                flow="up"
                (click)="deleteSlotProduct(dataItem)"
                class="actionIcon">
                <img src="../../../assets/icons/delete-icon.svg">
              </a>
            </ng-template>
          </kendo-grid-command-column>
          <!-- IF NO RESULTS COULD BE FOUND -->
          <ng-template kendoGridNoRecordsTemplate>
            <div class="text pl">{{ t("noResults") }}</div>
          </ng-template>
          <ng-template kendoGridLoadingTemplate>
            <div class="k-loading-color"></div>
            <div class="loading-container">
              <kendo-loader type="converging-spinner" size="large"></kendo-loader>
            </div>
          </ng-template>
        </kendo-grid>
        <!-- Slot Product Popup -->
        @if (slotProductOpened) {
          <kendo-dialog
            [title]="editingSlotProduct ? t('edit') : t('create')"
            (close)="closeSlotProductDialog('cancel')"
            [minWidth]="250"
            [width]="450">
            <kendo-formfield [hidden]="editingSlotProduct">
              <kendo-label [for]="productId" [text]="t('product')">*</kendo-label>
              <kendo-dropdownlist
                [data]="vm.searchResults"
                textField="name"
                valueField="id"
                [filterable]="true"
                (filterChange)="onFilter($event)"
                [loading]="vm.productSearchIsLoading"
                [defaultItem]="{ id: null, name: 'Artikel wählen', internalNumber: '' }"
                formControlName="productId"
                [valuePrimitive]="true"
                #productId>
                <ng-template kendoDropDownListItemTemplate let-dataItem>
                  {{ dataItem.name }}
                  @if (dataItem?.internalNumber) {
                    | {{ dataItem.internalNumber }}
                  }
                </ng-template>
                <ng-template kendoDropDownListValueTemplate let-selected>
                  {{ selected?.name }}
                  @if (selected?.internalNumber) {
                    | {{ selected?.internalNumber }}
                  }
                </ng-template>
              </kendo-dropdownlist>
              <kendo-formerror>{{tGlobal('errors.slotProducts.productLinkAlreadyExists')}}</kendo-formerror>
            </kendo-formfield>
            <kendo-formfield>
              <kendo-label [for]="targetStock" [text]="t('targetStock')">*</kendo-label>
              <kendo-numerictextbox
                formControlName="targetStock"
                [format]="'n0'"
                [min]="1"
                #targetStock>
              </kendo-numerictextbox>
            </kendo-formfield>
            <kendo-dialog-actions>
              <button
                [disabled]="slotProductForm.invalid || !slotProductForm.dirty"
                type="submit"
                kendoButton
                (click)="submitSlotProductCreation()"
                class="buttonPrimary">
                {{ editingSlotProduct ? t('update') : t('submit') }}
              </button>
              <button
                kendoButton
                (click)="closeSlotProductDialog('no')"
                class="buttonSecondary">
                {{t('cancel')}}
              </button>
              <button
                kendoButton
                class="buttonSecondary"
                (click)="removeSlotProduct()"
                [hidden]="!editingSlotProduct">
                <img src="../../../assets/icons/delete-icon.svg">
              </button>
            </kendo-dialog-actions>
          </kendo-dialog>
        }
      </form>
    }
  </ng-container>
</ng-container>